import { Injectable } from "@angular/core";
import { Worker } from "../_types/worker";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerCalendarEvent } from "../_types/worker-calendar-event";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class WorkersCalendarsEventsService extends Service<WorkerCalendarEvent> {
  public override type = 'workerCalendarEvents';
  public override url = 'providers/workerCalendarEvents';


  public saveWorkerCalendarEventsRange(workerId: string, data: any): Observable<void> {
    let headers = {
      'Content-Type': 'application/vnd.api+json'
    };
    let url = this.getAPIUrl() + "/" + workerId + '/saveWorkerCalendarEventsRange';
    return this.http.post<void>(url, data, { headers: headers });
  }

  public deleteWorkerCalendarEventsRange(workerId: string, workerCalendarEventsRange: any): Observable<void> {
    let headers = {
      'Content-Type': 'application/vnd.api+json'
    };
    let url = this.getAPIUrl() + "/" + workerId + '/deleteWorkerCalendarEventsRange';
    return this.http.post<void>(url, workerCalendarEventsRange, { headers: headers });
  }

   public deleteWorkerCalendarEventsRangeMasive(workerId: string, calendarEventTypeId: string, data: any): Observable<void> {
    let headers = {
      'Content-Type': 'application/vnd.api+json'
    };
    let url = this.getAPIUrl() + "/" + workerId + '/' + calendarEventTypeId + '/deleteWorkerCalendarEventsRangeMasive';
    return this.http.post<void>(url, data, { headers: headers });
  }


}
